import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useModalContext } from "../ModalContext";
import { fetchEditPermissions } from "../api/editpermissions";

const CustomButtonComponent = (params, status) => {
  const { openModalWithAScheme } = useModalContext();
  const [buttonStatus, setButtonStatus] = useState(1);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Scheme === 1);
    };

    fetchPermission();
  }, []);

  const handleActionClick = (mode) => {
    openModalWithAScheme(params, mode);
    if (mode === "repeat" || mode === "edit") {
      setButtonStatus(1);
    }
  };

  return (
    <div>
      {params.data.Status === 1 ? (
        <>
          <Button
            disabled={!isButtonEnabled}
            style={{
              flexGrow: 1,
              backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
              color: !isButtonEnabled ? "#9e9e9e" : "#fff",
              cursor: !isButtonEnabled ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              openModalWithAScheme(params, "repeat");
            }}
            variant="contained"
            color="primary"
            size="small"
          >
            Repeat
          </Button>
          <Button
            disabled={!isButtonEnabled}
            style={{
              flexGrow: 1,
              backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#fff",
              color: !isButtonEnabled ? "#9e9e9e" : "#16a695",
              cursor: !isButtonEnabled ? "not-allowed" : "pointer",
              borderColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
              marginLeft: "8px",
            }}
            onClick={() => {
              openModalWithAScheme(params, "edit");
            }}
            variant="outlined"
            color="primary"
            size="small"
          >
            Modify/Edit
          </Button>
        </>
      ) : (
        <>
          <Button
            style={{ flexGrow: 1, backgroundColor: "#16a695", color: "white" }}
            // onClick={() => alert('Confirm action')}
            onClick={() => {
              openModalWithAScheme(params, "approve");
            }}
            variant="contained"
            color="primary"
            size="small"
          >
            Approve
          </Button>
          <Button
            style={{
              flexGrow: 1,
              backgroundColor: "#ff1919",
              borderColor: "#ff1919",
              color: "#fff",
              marginLeft: "8px",
            }}
            onClick={() => {
              openModalWithAScheme(params, "reject");
            }}
            variant="outlined"
            color="primary"
            size="small"
          >
            Reject
          </Button>
        </>
      )}
    </div>
  );
};

export default CustomButtonComponent;
